var _path, _path2, _circle, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImg405({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 480,
    height: 320,
    viewBox: "0 0 480 320",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M132.37 88V176.34H151.3V207.89H132.37V231.03H95.56V207.89H23V176.34L94.51 88H132.37ZM95.56 134.48L61.7 176.34H95.56V134.48Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M389.158 139.36C410.065 139.36 425.425 143.769 435.238 152.587C445.194 161.262 450.172 172.711 450.172 186.933C450.172 196.32 447.683 204.996 442.705 212.96C437.869 220.782 430.332 227.182 420.092 232.16C409.852 236.996 397.123 239.413 381.905 239.413C371.381 239.413 360.856 238.276 350.332 236C339.949 233.724 330.847 230.382 323.025 225.973L340.092 188.853C346.349 192.409 352.892 195.111 359.718 196.96C366.687 198.809 373.443 199.733 379.985 199.733C385.816 199.733 390.509 198.738 394.065 196.747C397.763 194.613 399.612 191.698 399.612 188C399.612 184.444 397.976 181.813 394.705 180.107C391.434 178.258 385.532 177.333 376.998 177.333H333.692L341.158 86.6666H440.358V124.64H382.545L381.478 139.36H389.158Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 240,
    cy: 160,
    r: 83,
    stroke: "#FF7B2E",
    strokeOpacity: 0.6,
    strokeWidth: 20
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M245.667 190.961H235.334V204.66H245.667V190.961Z",
    fill: "#FF7B2E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M245.667 180.687H235.333L225 114.45H256L245.667 180.687Z",
    fill: "#FF7B2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg405);
export default __webpack_public_path__ + "static/media/img_405.7556abd3fa400ea7fb46f5ff41bfb718.svg";
export { ForwardRef as ReactComponent };